import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import Detail from "@/views/Detail";
import Error from "@/views/Error";
import Landing from "@/views/Landing";
import ShopIndex from "@/views/customer/Index.vue";

import LpaHome from "@/views/lpa/Home.vue";
import LpaDetail from "@/views/lpa/Detail.vue";

import {
  HOME,
  DETAIL,
  ERROR,
  // LANDING,
  SHOP_INDEX,
  APP_STORAGE_WEB_KEY,
  APP_STORAGE_LANGUAGE_KEY,
  LPA_HOME,
  LPA_DETAIL,
} from "@/router/constant";

import { SETUP, SET_TOKEN } from "@/store/actions/auth";

import store from "@/store/index.js";
import jwt_decode from "jwt-decode";

// import {
//     SETUP,
//   } from '@/store/actions/auth';
//   import store from '@/store/index.js';

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  // const system = to.params.env ? to.params.env : "hsa";
  // const system = to.meta.env ? to.meta.env : "hsa";
  const system =
    to.matched.find((r) => r.meta && r.meta.env)?.meta.env || "hsa";
  store.dispatch(SETUP, { system });

  // document.title = to.meta.title || process.env.VUE_APP_APPLICATION_NAME;
  console.log("to", to);
  console.log("from", from);
  console.log("next", next);

  const q = to.query.token;
  console.log("q", q);

  if (q) {
    const decoded = jwt_decode(q);
    const exp = decoded.exp;
    const now = Date.now() / 1000;

    console.log("exp", exp);
    console.log("now", now);
    console.log("decoded", decoded);

    if (exp >= now) {
      // store.dispatch(SET_TOKEN, { token: q, payload: decoded });
      store.dispatch(SET_TOKEN, {
        token: q,
        payload: decoded || null,
      });

      next();
    } else {
      console.log("error token expired");
      next({
        path: "/error/EXPIRED",
      });
    }
  } else {
    console.log("error no token");
    next({
      path: "/error/UNAUTHORIZED",
    });
  }
};

const ifCustomerAuthenticated = (to, from, next) => {
  let token = to.query.token;
  const langCode = to.query.lang ?? "th";
  // const bookingNo = to.params.bookingNo;

  if (!token) {
    token = JSON.parse(localStorage.getItem(APP_STORAGE_WEB_KEY))?.accessToken;
  }

  const arrayToken = token.split(".");
  const tokenPayload = JSON.parse(atob(arrayToken[1]));
  const bookingNo = tokenPayload?.BookingNo ?? null;
  // console.log(tokenPayload);
  console.log("bookingNo", bookingNo);

  if (!token || !bookingNo) {
    next({
      path: "/error/UNAUTHORIZED",
    });

    return;
  }

  const storeData = {
    accessToken: token,
    bookingNo: bookingNo,
  };

  localStorage.setItem(APP_STORAGE_WEB_KEY, JSON.stringify(storeData));

  const storeLangData = {
    langCode: langCode,
  };
  localStorage.setItem(APP_STORAGE_LANGUAGE_KEY, JSON.stringify(storeLangData));

  next();
};

// const ifHasToken = (to, from, next) => {
//     document.title = to.meta.title || process.env.VUE_APP_APPLICATION_NAME;
//     console.log('to', to);
//     console.log('from', from);
//     console.log('next', next);

//     const accessToken = JSON.parse(localStorage.getItem("vendor_app")).token;

//     if (accessToken) {
//         const now = Date.now() / 1000;
//         const exp = JSON.parse(localStorage.getItem("vendor_app")).payload.exp;

//         const isExpired = (exp < now);
//         if (!isExpired) {
//             next();
//         } else {
//             next({
//                 path: '/error',
//             });
//         }
//     } else {
//         next({
//             path: '/error',
//         });
//     }
// };

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/error",
    },
    // {
    //   path: "/:env?/landing",
    //   name: "LANDING",
    //   component: Landing,
    //   beforeEnter: ifAuthenticated,
    // },
    {
      path: "/hsa/landing",
      meta: { env: "hsa" },
      name: "LANDING",
      component: Landing,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/hsa/home",
      meta: { env: "hsa" },
      name: HOME,
      component: Home,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/hsa/booking/:id",
      meta: { env: "hsa" },
      name: DETAIL,
      component: Detail,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/hsa/error/:code?",
      name: ERROR,
      component: Error,
    },
    
    {
      path: "/lpa/landing",
      meta: { env: "lpa" },
      name: "LANDING",
      component: Landing,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/lpa/home",
      meta: { env: "lpa" },
      name: LPA_HOME,
      component: LpaHome,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/lpa/booking/:id",
      meta: { env: "lpa" },
      name: LPA_DETAIL,
      component: LpaDetail,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/lpa/error/:code?",
      name: ERROR,
      component: Error,
    },
    // {
    //   path: "/lpa/",
    //   meta: { env: "lpa" },
    //   children: [
    //     {
    //       path: "home",
    //       name: LPA_HOME,
    //       component: LpaHome,
    //       beforeEnter: ifAuthenticated,
    //     },
    //     {
    //       path: "booking/:id",
    //       name: LPA_DETAIL,
    //       component: LpaDetail,
    //       beforeEnter: ifAuthenticated,
    //     },
    //   ],
    // },
    // {
    //   path: "/:env?/home",
    //   name: HOME,
    //   component: Home,
    //   beforeEnter: ifAuthenticated,
    // },
    // {
    //   path: "/:env?/booking/:id",
    //   name: DETAIL,
    //   component: Detail,
    //   beforeEnter: ifAuthenticated,
    // },
    // {
    //   path: "/:env?/error/:code?",
    //   name: ERROR,
    //   component: Error,
    // },
    {
      path: "/customer/shop/bookings/:bookingNo?/payment-transactions",
      name: SHOP_INDEX,
      component: ShopIndex,
      beforeEnter: ifCustomerAuthenticated,
    },
    // {
    //     path: '/',
    //     redirect: '/error',
    // },
    // {
    //     path: '/:env?/landing',
    //     name: 'LANDING',
    //     component: Landing,
    //     beforeEnter: ifAuthenticated,
    // },
    // {
    //     path: '/landing',
    //     name: 'LANDING',
    //     component: Landing,
    //     beforeEnter: ifAuthenticated,
    // },
    // {
    //     path: '/home',
    //     name: HOME,
    //     component: Home,
    //     beforeEnter: ifAuthenticated,
    // },
    // {
    //     path: '/booking/:id',
    //     name: DETAIL,
    //     component: Detail,
    //     beforeEnter: ifAuthenticated,
    // },
    // {
    //     path: '/error/:code?',
    //     name: ERROR,
    //     component: Error,
    // },
  ],
});
